module.exports = __webpack_public_path__ + "static/odihome-ce7a2c588c2cbc7ae20be8b67541e5aa.jpg";